import { render } from "./InnerHeading.vue?vue&type=template&id=45250db8"
import script from "./InnerHeading.vue?vue&type=script&lang=js"
export * from "./InnerHeading.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__